import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { deepCopy, makeid, removeUndefined, removeUndefinedValuesFromObject } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
    selector: 'app-oneclikpay-item-dialog',
    templateUrl: './oneclikpay-item-dialog.component.html',
    styleUrl: './oneclikpay-item-dialog.component.css',
    standalone: false
})
export class OneclikpayItemDialogComponent {
  itemEditForm!:FormGroup
  itemData:any
  oldData:any

  constructor(public dialogRef: MatDialogRef<OneclikpayItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private commentService: CommentsService,
    private fb: FormBuilder,
    private settingsService: SettingsService){
      dialogRef.disableClose=true
  }

  ngOnInit(): void {
      
    this.itemData=deepCopy(this.data)
    this.oldData=deepCopy(this.data)

    this.itemEditForm = this.fb.group({
      id:[],
      images:[],
      productId:[],
      title:[],
      description:[],
      priceAmount:[ , Validators.required],
      priceCurrency:[],
      priceVat:[]
    })

    const {id,images, productId, title, description, price } = this.itemData
    this.itemEditForm.patchValue({
      id:id ? id : makeid(5),
      images:images ? images : undefined,
      productId:productId ? productId : undefined,
      title: title ? title : undefined,
      description:description ? description : undefined,
      priceAmount:price?.amount ? price.amount : 0,
      priceCurrency: price?.currency ? price.currency : "euro",
      priceVat: price?.vat ? price.vat : 0
    })

  }

  saveChanges(){
    this.commentService.progressSpin.emit(true)
    const form = this.itemEditForm.value
    const data = {
      id:form.id ? form.id : makeid(5),
      images: form.images ? form.images : undefined,
      productId: form.productId ? form.productId : undefined,
      title: form.title ? form.title : undefined,
      description: form.description ? form.description : undefined,
      price:{
        amount: form.priceAmount ? form.priceAmount : 0,
        currency: form.priceCurrency ? form.priceCurrency : "euro",
        vat: form?.priceVat ? form.priceVat : undefined
      }
      
    }
    if(data.images?.length==0)
    delete data.images

    removeUndefined(data)
    this.dialogRef.close([ true, data]);
    this.commentService.progressSpin.emit(false)      
  }

}
